export const NONE = 'None';
